export const educationData = [
    {
        id: 1,
        institution: 'Bal Udhyan Sikshan Sansthan',
        course: 'High School',
        startYear: '2008',
        endYear: '2011'
    },
    {
        id: 2,
        institution: 'Pt. Deen Dayal Upadhyaya Kanpur',
        course: 'Intermediate',
        startYear: '2011',
        endYear: '2013'
    },
    {
        id: 3,
        institution: 'KIET Ghaziabad',
        course: 'Bachelor of Technology',
        startYear: '2014',
        endYear: '2018'
    },
]